import { networkBoundResource, unwrapApiWrapper } from '@/repositories/BaseCrudRepository';
import Product from '@/repositories/data/webshop/Product';
import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';
import Resource from '@/repositories/Resource';
import ApiWrapper from '@/repositories/data/ApiWrapper';
import ProductInventoryState from '@/repositories/data/webshop/ProductInventoryState';
import PositionableCrudRepository from '@/repositories/PositionableCrudRepository';

export default class ProductRepository extends PositionableCrudRepository<number, Product, Product> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/product/');
    }

    public getStatus(id: number): Observable<Resource<ProductInventoryState>> {
        const observable = this.client.get<ApiWrapper<ProductInventoryState>>(this.formatId(id) + '/inventory', {
            baseUrl: this.baseUrl,
        });
        return networkBoundResource(unwrapApiWrapper(observable));
    }
}
